import { useUserStore } from '@/store/modules/user/store.js';
import { authService } from '@/plugins/vue-auth.ts';

export const redirectToFirstAvailableFlowRoute = (requestRoute) => {
    const user = useUserStore().authUser;

    let orderedFlowRoutes = ['flow.webBoost', 'flow.phoneUp', 'flow.leadXpress'];

    if (requestRoute) {
        orderedFlowRoutes = orderedFlowRoutes.filter((flowRoute) => flowRoute !== requestRoute);
        orderedFlowRoutes.unshift(requestRoute);
    }

    const availableFlowRoute = orderedFlowRoutes.find((flowRoute) => user.hasAccessTo(flowRoute));

    return { name: availableFlowRoute || 'unauthorized' };
};

export default {
    async beforeRouteEnter(to, from, next) {
        if (!authService.ready()) {
            await authService.waitForUser();
        }

        const route = redirectToFirstAvailableFlowRoute(to.name);

        if (route.name === to.name) {
            next();
        } else {
            next(route);
        }
    },

    async beforeRouteUpdate(to, from, next) {
        if (!authService.ready()) {
            await authService.waitForUser();
        }

        const route = redirectToFirstAvailableFlowRoute(to.name);

        if (route.name === to.name) {
            next();
        } else {
            next(route);
        }
    },
};
